import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-cross\"><path fill=\"none\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"m.75.75 13.5 13.5m0-13.5L.75 14.25\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol